import { useAppContext } from 'context/app-context';
import { useMemo } from 'react';
import { PerformanceBucket } from 'types/configs';
import { Device, getDevice, getModelName } from 'utils/getDevice';
import { PerformanceFeatureFlagUtil } from 'utils/PerformanceFeatureFlagUtil';
import { isWebos4 } from 'utils/webos/webos-utils';

const device = getDevice();

/**
 * # usePerformanceBucket
 *
 * This hook determines if a the device is considered High-end, Average, or Low-end.
 *
 * To be used to determine if a device is powerful enough to accommodate a given feature.
 */
export default function usePerformanceBucket(): PerformanceBucket {
  const { appConfig, webosDeviceInfo } = useAppContext();
  const modelName = getModelName(); // get this in the hook since vegaos may not have updated when checking at module loading time

  const performanceBucket = useMemo(() => {
    if (device === Device.lgtv && isWebos4(webosDeviceInfo)) return PerformanceBucket.LowEnd;

    // assume it's Average unless otherwise specified.
    if (!appConfig?.performance) return PerformanceBucket.Average;

    const performanceBucket =
      (Object.entries(appConfig.performance) as [PerformanceBucket, string][]).find(([, value]) =>
        value.split(',').includes(modelName),
      )?.[0] ?? PerformanceBucket.Average;

    PerformanceFeatureFlagUtil.performanceBucket = performanceBucket;

    return performanceBucket;
  }, [appConfig?.performance, webosDeviceInfo, modelName]);

  return performanceBucket;
}
